// import { fontWeight } from 'html2canvas/dist/types/css/property-descriptors/font-weight';
import React, { memo, useState } from 'react';
import Chart from 'react-apexcharts';

const LineChart = memo(({ data, type }) => {
  console.log(data, 'LineChartData');
  const num = parseInt(data?.Percentage, 10) ? parseInt(data?.Percentage, 10) : 0;
  // const lineColor = num >= 0 ? '#6fcf97' : '#ff5252';
  const lineColor = type === 'Charges' ? '#3379ff' : type === 'Denied' ?  '#FF2C2C' : '';
  const lineColorList = type === 'Charges' ? ['#3379ff'] : type === 'Denied' ?  ['#FF2C2C'] : [];

  const formatRange = (range) => {
    if (!range) return '';
    const [startDate, endDate] = range.split(' - ');
    if (!startDate || !endDate) return range;

    const [sm, sd] = startDate.split('/');
    const [em, ed] = endDate.split('/');

    return `${sm}/${sd} - ${em}/${ed}`;
  };

  const initialOptions = {
    chart: {
      type: 'line',
      animations: {
        enabled: true,
        easing: 'easeinout',
        speed: 800,
        animateGradually: { enabled: true, delay: 150 },
        dynamicAnimation: { enabled: true, speed: 350 },
      },
      toolbar: { show: false },
      sparkline: { enabled: false },
    },
    markers: {
      size: 4,
      colors: [lineColor],
      strokeColor: '#fff',
      strokeWidth: 2,
      hover: { size: 6 },
    },
    series: [{ name: type, data: data?.data }],
    xaxis: {
      categories: data?.DateRange || [],
      labels: {
        show: true,
        rotate: 0,
        trim: false,
        offsetX: -1,
        formatter: (val) => formatRange(val),
        style: {
          fontSize: '11px',
          fontFamily: 'Poppins',
          fontWeight: '400',
          colors: '#434343',
        },
      },
      axisBorder: { show: true },
      axisTicks: { show: true },
      tooltip: { enabled: false },
      tickPlacement: "between",
    },
    yaxis: {
      show: true,
      labels: {
        show: true,
        offsetX: -15,
        formatter: (val) => `$${(val / 1000).toFixed(0)}k`,
        style: {
          fontSize: '11px',
          fontFamily: 'Poppins',
          fontWeight: '400',
          colors: ['#434343'],
        },
      },
      tickAmount: 3,
    },
    fill: {
      opacity: 1,
    },
    plotOptions: {
      line: {
        distributed: true, // evenly distribute points
      },
    },
    stroke: { width: 2, curve: 'smooth' },
    dataLabels: { enabled: false },
    tooltip: {
      custom: ({ series, seriesIndex, dataPointIndex, w }) => {
        const formatter = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
        const totalAmount = data?.data?.reduce((total, num) => total + num, 0);
        // const totalAmount = formatter.format(data?.PreviousMonthAmount || 0);

        // Header
        const header = `
          <div class="d-flex justify-content-between">
            <p class="xsm_heading">${type === 'Patient Payments' ? 'Pat. Payments' : type
          }</p>
          <p class="xsm_heading">${`$${totalAmount}`}</p>

          </div>
          <div class="app_border border-end-0 border-start-0 border-top-0 pt-1-5 mb-06-px"></div>
        `;

        // Rows with "MM/DD - MM/DD"
        const rows = data?.DateRange?.map((label, i) => {
          const formattedLabel = formatRange(label);
          const value = formatter.format(data?.data?.[i] || 0);
          return `
            <div class="d-flex justify-content-between mt-1" style="width: 160px;">
              <p class="xsm_text">
                <span style="display: inline-block; background-color: ${w.globals.colors[0]
            }; width: 6px; height: 6px; border-radius: 3px; margin-right: 5px;"></span>
                ${formattedLabel}
              </p>
              <p class="xsm_text">${value}</p>
            </div>
          `;
        }).join('');

        return `
          <div class="apexcharts-tooltip-title m-0">
            ${header}
            ${rows}
          </div>
        `;
      },
    },
    grid: {
      show: true,
      borderColor: '#f4f4f4',
      strokeWidth: 0.25,
    },
    // '#3379ff'
    colors: lineColorList,
  };

  const [state] = useState(initialOptions);

  return (
    <Chart
      options={state}
      series={state.series}
      type={state.chart.type}
      height="140"
      width="100%"
    />
  );
});

export default LineChart;
